
import * as myProviderRuntime$yyTyNO5bdk from '/app/utils/image-provider.ts'
import * as ipxRuntime$33532Hyu9T from '/app/node_modules/.pnpm/@nuxt+image@1.9.0_rollup@4.20.0/node_modules/@nuxt/image/dist/runtime/providers/ipx'

export const imageOptions = {
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "ipx",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
}

imageOptions.providers = {
  ['myProvider']: { provider: myProviderRuntime$yyTyNO5bdk, defaults: undefined },
  ['ipx']: { provider: ipxRuntime$33532Hyu9T, defaults: {} }
}
        